// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cn38","col":"styles_col__218-g"};